module.exports = __webpack_public_path__ + "img/Mstorybg501.8d438ee1.png";